export const META = {
  favicon: "/favicon.ico",
  title: "Pency",
  theme: "#FFFFFF",
  fbapp: "236717644287641",
  appleicon: "/logo192.jpg",
  author: "Pency",
  twitter: "@pencyapp",
  banner: {
    url: "/og-image.jpg",
    format: "image/jpeg",
    width: "1200",
    height: "630",
  },
};
